export enum WindSimVersion {
  Version11 = 1100,
  Version12 = 1200,
}
